// schema
import { User, UserType } from '@schemas'

export const UserList = {
	listSort: (userList: User[]) => {
		userList.sort((a: UserType, b: UserType) => {
			const order = a.name < b.name ? -1 : a.name > b.name ? 1 : 0

			return order
		})
	},
}
